<mat-card>
  <mat-card-title>{{ viewMode ? 'Resource Details' : 'Edit Resource' }}</mat-card-title>
  <mat-card-content>
    <form *ngIf="!viewMode" [formGroup]="editForm" (ngSubmit)="saveChanges()">
      <mat-form-field appearance="fill">
        <mat-label>Name</mat-label>
        <input matInput formControlName="name">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Resource Folder</mat-label>
        <input matInput formControlName="path">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>Resource Type</mat-label>
        <input matInput formControlName="resourceType">
      </mat-form-field>

      <mat-checkbox formControlName="isHyperlink" (change)="onIsHyperlinkChange()">Is Hyperlink</mat-checkbox>

      <!-- Upload File Field -->
      <div>
        <label for="file-upload">Upload File:</label>
        <input id="file-upload" type="file" (change)="onFileSelected($event)" [disabled]="editForm.get('isHyperlink')?.value">
      </div>

      <div class="form-actions">
        <button mat-raised-button color="primary" type="submit">Save</button>
        <button mat-raised-button color="warn" type="button" (click)="closeDialog()">Cancel</button>
      </div>
    </form>

    <div *ngIf="viewMode">
      <p><strong>Name:</strong> {{ data.resource?.name }}</p>
      <p><strong>Path:</strong> {{ data.resource?.path }}</p>
      <p><strong>Resource Type:</strong> {{ data.resource?.resourceType }}</p>
      <p><strong>Is Hyperlink:</strong> {{ data.resource?.isHyperlink ? 'Yes' : 'No' }}</p>      
    </div>
  </mat-card-content>
</mat-card>
